<button [routerLink]="['/picklist']" class="goback">
  <i class="bi bi-arrow-left"></i> Picklist
</button>
<div class="transfer-out-form content-info">
  <h4>Create Picklist</h4>
  <div class="row mb-2">
    <div class="col-md-3 mb-3">
      <label class="form-label">Select GRN</label>
      <ng-select
        [items]="grns"
        bindLabel="grnNumber"
        bindValue="grnId"
        [(ngModel)]="selectedGrnId"
        [searchable]="true"
        placeholder="Select GRN"
        (change)="onGrnChange($event)"
        [disabled]="viewOnly"
        >
      </ng-select>
    </div>
  </div>

  @if (storeKeys.length) {
    <div class="row mb-2">
      <div class="d-flex justify-content-end mb-3">
        <button
          type="button"
          class="btn btn-outline-primary me-2"
          (click)="printTable()"
          >
          <i class="fas fa-print me-1"></i> Print
        </button>
      </div>
      <div id="printSection">
        <table class="table table-bordered text-center" id="printableTable">
          <thead>
            <tr>
              <th rowspan="2">SKU Code</th>
              <th rowspan="2">SKU DESC</th>
              <th rowspan="2">GRN QTY</th>
              <!-- Indent group -->
              <th [attr.colspan]="storeKeys.length + 1">INDENT</th>
              <!-- Allocation group -->
              <th [attr.colspan]="storeKeys.length + 1">ALLOCATION</th>
            </tr>
            <tr>
              <!-- Dynamic INDENT store names -->
              @for (store of storeKeys; track store) {
                <th>{{ store }}</th>
              }
              <th>TOTAL</th>
              <!-- Dynamic ALLOCATION store names -->
              @for (store of storeKeys; track store) {
                <th>{{ store }}</th>
              }
              <th>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            @for (row of picklistData; track row) {
              <tr>
                <td>{{ row.sku }}</td>
                <td>{{ row.productName }}</td>
                <td>{{ row.grnQty }}</td>
                <!-- INDENT values -->
                @for (store of storeKeys; track store) {
                  <td>
                    {{ row.indents[store] || 0 }}
                  </td>
                }
                <td>{{ row.indents.TOTAL }}</td>
                <!-- ALLOCATION values -->
                @for (store of storeKeys; track store) {
                  <td>
                    {{ row.finalPicklist[store] || 0 }}
                  </td>
                }
                <td>{{ row.finalPicklist.TOTAL }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      @if (!viewOnly) {
        <div class="title-actions text-end">
          <button type="button" class="btn btnsecondary m-2" disabled="viewOnly">
            Cancel
          </button>
          @if (!isEditMode) {
            <button
              type="button"
              class="btn btn-warning m-2"
              (click)="saveDraft()"
              >
              Save Draft
            </button>
          }
          <button type="button" class="btn btnprimary" (click)="savePickList()">
            Submit
          </button>
        </div>
      }
    </div>
  }
</div>
<div id="printSection" style="display: none"></div>
